import {
  startViewsReducerPerformanceMeasure,
  VIEWS_REDUCER_PERFORMANCE_MIN_DURATION_MS,
} from './reducerPerformance';

export const IMMUTABLE_PERFORMANCE_MIN_DURATION_MS =
  VIEWS_REDUCER_PERFORMANCE_MIN_DURATION_MS;

/**
 * Starts a synchronous views immutable measurement and returns an idempotent
 * callback that reports actions exceeding the configured duration threshold.
 */
export function startImmutablePerformanceMeasure(
  actionType: string
): () => void {
  return startViewsReducerPerformanceMeasure('immutable', actionType);
}
